import React from 'react'
import './css/About.css'

function Aboutus() {
  return (
    <div id='aboutis'>
{/* Founder Section */}
<div className='about-layer-05'>
  <h2>About the Founder</h2>

  <div className='profile-card'>

    <h3>VIKAS DODDAMANI</h3>
    <p className='location'>
      Dharwad, Karnataka – 580001 | 
      mailtovikasdoddamani@gmail.com | 
      +91 8884707098
    </p>

    <p>
      Full Stack Developer with <b>7+ years of experience</b> including technical support, 
      specializing in Python, MERN Stack, Laravel, and scalable enterprise applications. 
      Strong expertise in REST API development, microservices architecture, and AI integration. 
      Experienced in delivering <b>international freelance projects</b> and building secure, 
      high-performance systems for global clients.
    </p>

    {/* Skills */}
    <div className='profile-skills'>
      <h4>Core Skills</h4>
      <p>
        Python, JavaScript, PHP, Java | Django, FastAPI, Flask, Node.js, Express.js, Spring Boot |
        React.js, Angular | MySQL, PostgreSQL, MongoDB | REST APIs, JWT, RBAC, Microservices, AI Integration
      </p>
    </div>

    {/* Experience */}
    <div className='profile-experience'>
      <h4>Professional Experience</h4>
      <ul>
        <li><b>MOSERP Technologies Pvt Ltd</b> – Technical Support Executive (2025–Present)</li>
        <li><b>COPAO Technologies Pvt Ltd</b> – Full Stack Developer and Products Manager (2022–2025)</li>
        <li><b>Iron Hawk Technologies</b> – Full Stack Developer (2020–2022)</li>
        <li><b>Ananya Technologies</b> – Web Developer (2015–2017)</li>
      </ul>
    </div>

    {/* Projects */}
    {/* <div className='profile-projects'>
      <h4>International Projects</h4>
      <ul>
        <li><b>WeeToys</b> – E-commerce platform (PHP, MySQL)</li>
        <li><b>Adya Institute (Germany)</b> – Educational Website (WordPress)</li>
        <li><b>PROCUREFOREU B.V (Netherlands)</b> – MERN Stack Procurement System</li>
      </ul>
    </div> */}

  </div>
</div>


      {/* Intro */}
      <div className='about-layer-01'>
        <h1>About Doddamani TechDev Pvt Ltd</h1>
        <p>
          In today's digital age, having a strong online presence is essential for businesses 
          to grow and succeed. At Doddamani TechDev Pvt Ltd, we specialize in transforming 
          ideas into powerful digital solutions. We help businesses, startups, and students 
          move from offline to online with modern technologies.
        </p>
      </div>

      {/* Company Description */}
      <div className='about-layer-02'>
        <p>
          We provide services such as Web Application Development, Mobile Applications, 
          Desktop Software, IoT Projects, and Student Academic Projects. Our expert team 
          ensures high-quality solutions tailored to your needs.
        </p>

        <p>
          Our services are available both <b>online and offline</b>, and we proudly serve 
          clients across <b>state, national, and international levels</b>.
        </p>
      </div>

      {/* Mission & Vision */}
      <div className='about-layer-03'>
        <div className='about-card'>
          <h2>Our Mission</h2>
          <p>
            To deliver innovative and reliable software solutions that empower businesses 
            and students to achieve success in the digital world.
          </p>
        </div>

        <div className='about-card'>
          <h2>Our Vision</h2>
          <p>
            To become a leading technology company known for quality, innovation, and 
            customer satisfaction globally.
          </p>
        </div>
      </div>

      {/* Why Choose Us */}
      <div className='about-layer-04'>
        <h2>Why Choose Us</h2>
        <ul>
          <li>✔ Experienced and skilled developers</li>
          <li>✔ Customized solutions for every client</li>
          <li>✔ Affordable pricing</li>
          <li>✔ Latest technologies (React, Node, Python, IoT)</li>
          <li>✔ Online & Offline support</li>
        </ul>
      </div>

    </div>
  )
}

export default Aboutus